import Logout from './components/logout';

export const routes = [
  { path: '/signout', name: 'signout', component: Logout, display: '', style: '' }
];
